import React from 'react';

const videos = [
  {
    title: 'CMA Awards – Surprise Performance',
    subtitle: 'Roosevelt with Jelly Roll',
    youtubeId: 'GmKnX99eyNs'
  },
  {
    title: 'Jelly Roll - "Winning Streak" (Live on SNL)',
    subtitle: 'Roosevelt Collier as Music Director',
    youtubeId: '7MujD0ZW_fo'
  },
  {
    title: 'Jelly Roll - "Liar"',
    subtitle: 'Official Music Video',
    youtubeId: 'YLK6-ARJB8w'
  },
  {
    title: 'at Rio das Ostras Jazz & Blues Festival 2021',
    subtitle: 'featuring. Jimmy James',
    youtubeId: 'mU5xBF3uwlA'
  },
  {
    title: 'Summer Rose (Official Music Video)',
    youtubeId: 'xNgT39todXc'
  },
  {
    title: 'Live at Ronnie Scott\'s',
    subtitle: 'Watch the recorded livestream of a nearly 2-hour set at the legendary Ronnie Scott\'s in London.',
    youtubeId: '3JAZkZA1eRg'
  },
  {
    title: 'Welcome to Exit 16',
    subtitle: 'An inside look at the debut album',
    youtubeId: '8P3puCHiTpQ'
  },
  {
    title: 'Supernatural Encounters',
    subtitle: 'Official Music Video',
    youtubeId: 'nalfI4P-bkg'
  },
  {
    title: 'Live at Montreaux',
    id: 'liveatmontreaux',
    subtitle: 'with the Roosevelt Collier Band',
    youtubeId: 'Vg7likJhXIM'
  },
  {
    title: 'Spike',
    subtitle: 'Official Music Video',
    youtubeId: '9_8JZL1lBmw'
  },
  {
    title: 'Let The Steel Play',
    id: 'letthesteelplay',
    subtitle: 'Roosevelt Collier & Andy Hall',
    youtubeId: 'l57tZrFl8e0'
  },
  {
    title: 'Live at Paste Studios',
    id: 'liveatpastestudios',
    subtitle: 'with the Roosevelt Collier Band',
    youtubeId: 'G-2W_HO8BPg'
  },
  {
    title: 'Exit 16',
    subtitle: 'Official Music Video',
    youtubeId: 'P8jyKnLLXPc'
  },
  {
    title: '"Amazing Grace" live on B.R.I. TV',
    subtitle: 'Roosevelt at Blues Radio International Studios',
    youtubeId: '2I-K2R0e45U'
  }
];

export default videos;
